import { Link, useNavigate } from 'react-router';
import { useBotRoute } from '../lib/useBotRoute';
import { botPath } from '../lib/botNav';
import { useEffect } from 'react';
import { useTenant } from '../contexts/TenantContext';
import { BotToolsManager } from '../components/tools/BotToolsManager';


export function BotTools() {
  const { system, botId } = useBotRoute();
  const navigate = useNavigate();
  const { tenants, tenantBots } = useTenant();

  const tenant = tenants?.find((t) => {
    const bots = tenantBots?.[t.id] ?? [];
    return bots.some((b) => b.botId === botId);
  });
  const bots = tenant ? tenantBots?.[tenant.id] ?? [] : [];
  const hasAccess = bots.some((b) => b.botId === botId);
  const bot = bots.find((b) => b.botId === botId);

  useEffect(() => {
    if (!tenant || !hasAccess) {
      navigate('/');
    }
  }, [tenant, hasAccess, navigate]);

  if (!tenant || !hasAccess || !botId || !bot?.id) return null;

  return (
    <div className="h-full w-full overflow-y-auto bg-gray-50">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 py-8 sm:py-12">
        <div className="flex items-center gap-4 mb-6">
          <Link to={botPath({ system, botId }, 'config')} className="text-gray-500 hover:text-gray-700 text-sm">
            ← Bot Config
          </Link>
          <h1 className="text-2xl sm:text-3xl font-bold text-gray-900">{bot?.botName || botId} · Tools</h1>
        </div>
        <p className="text-gray-600 mb-6">
          Manage tool definitions for this bot, including edit and custom test flow before enabling in production.
        </p>
        <BotToolsManager botId={String(bot.id)} system={system} />
      </div>
    </div>
  );
}

export default BotTools;

